import React from 'react';
import BulkImport from '../BulkImport';

const BulkImportV3 = (props) => (
  <div className="v3-card-dark rounded-3xl p-4 md:p-6 shadow-2xl v3-bulk-wrap">
    <div className="mb-4 px-2">
      <p className="text-xs font-semibold tracking-widest text-slate-400 uppercase mb-1">Importar</p>
      <h2 className="text-2xl md:text-3xl font-bold text-white">Nuevas transacciones</h2>
      <p className="text-xs text-slate-500 mt-1">Arrastra capturas o pega texto desde el banco</p>
    </div>
    <BulkImport {...props} />
  </div>
);

export default BulkImportV3;
